import { render, staticRenderFns } from "./ServiceInformationWidget.vue?vue&type=template&id=1b8a1e0a&"
import script from "./ServiceInformationWidget.vue?vue&type=script&lang=js&"
export * from "./ServiceInformationWidget.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInformationWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports